module.exports = __webpack_public_path__ + "static/media/02.cf4a8241.mp3";